import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-uikit/Dropdown";

interface ArchiveProps {
  onClick?: () => void;
}

export const Archive = ({ onClick }: ArchiveProps) => (
  <Dropdown.ItemWithLink onClick={onClick}>
    {t("settings.workflows.table.actions.archive")}
  </Dropdown.ItemWithLink>
);
